export const ModuleName = 'oversikt';
export const DisplayName = 'Översikt';

export type LakemedelChartDisplayModes = 'regim' | 'substans';

export const LakemedelChartDisplayMode = {
    Regimer: 'regim',
    Substanser: 'substans',
} satisfies Record<string, LakemedelChartDisplayModes>;
